<template>
  <div id="redirect-sso" style="max-width: 32rem;">
    <div class="_flex:column _m:top(4) _p:x(3) _m:x(1)">

    <div v-if="isLoading">
      <p class="h6 _m:top(2) _m:bottom(4)">
       {{ $t('shared.message.loading')}}
      </p>
      <p class="_text:sm _m:bottom(3)">
        {{ $t('view.RedirectSSO.description')}}
      </p>

         <Loader v-show="isLoading" />
    </div>

      <p class="_text:sm _m:bottom(3)" v-if="error">
        <ds
            ds="tag"
            version="error"
            icon="info"
            :label="error"
            size="lg"
            iconSize="1em"
            isSquare
            class="_m:top(3) _p(3)"
            style="width: 100%;"
            />
      </p>

       <p v-html="$t('shared.action.contactUs')" class="_text:sm _text-grey-900 _m:x(auto) _m:bottom(0)"/>

    </div>

  </div>
</template>

<script>

import { eventBus } from '@/eventBus';
import { LoggerService } from '@/services';
import { Loader } from '@/components';
import { mapActions } from 'vuex';

export default {
  name: 'RedirectSSO',
  data: () => ({
    jwt: '',
    isLoading: false,
    error: undefined
  }),
  components: {
    Loader
  },
  methods: {
    ...mapActions({
      fetchSSOLogin: 'tokeny/SSOLogin',
      fetchInvestorAllowed: 'qualification/fetchInvestorAllowed',
      reset: 'qualification/reset'
    })
  },

  async mounted () {
    this.isLoading = true;
    eventBus.$emit('isSubmitting', true);
    this.reset();

    try {
      const query = new URLSearchParams(location.search);
      if (query.get('jwt')) {
        this.jwt = query.get('jwt');
        await this.fetchSSOLogin({ jwt: this.jwt });

        const isAllowed = await this.fetchInvestorAllowed();

        if (isAllowed === 'ERROR_IDENTITY_NOT_COMPLETE') {
          this.$router.push({ name: 'sign-in-info' });
        } else if (isAllowed === 'ERROR_COUNTRY_NOT_ALLOWED') {
          throw Error(this.$t('apiErrorCodes.ERROR_COUNTRY_NOT_ALLOWED'));
        } else {
          this.$router.push({ name: 'appIndex' });
        }
      } else {
        throw Error('No JWT token found');
      }
    } catch (e) {
      if (e.error) { this.error = e.error; }
      if (e.message) { this.error = e.message; }
      LoggerService.error(this.error);
    }

    this.isLoading = false;
    eventBus.$emit('isSubmitting', false);
  }
};
</script>
